import Button from "../../../../components/Button/Button";
import { Section, Card } from "../Account/accountParts";

const HEADERS = ["Type", "Prefix", "Code", "Code Preview"];

const ObjectCodesView = ({ includeYear, codes, canEdit, onEdit }) => (
  <Section
    title="Custom Codes"
    large
    actions={
      canEdit && (
        <Button size="sm" onClick={onEdit}>
          Update
        </Button>
      )
    }
  >
    <Card className="space-y-4">
      {/* The year flag drives every preview below, so it is stated first. */}
      <div className="flex items-center gap-2 text-sm">
        <span className="text-xs font-medium text-gray-500">
          Include year in codes:
        </span>
        <span
          className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${
            includeYear
              ? "bg-success-100 text-success-800"
              : "bg-gray-100 text-gray-600"
          }`}
        >
          {includeYear ? "Yes" : "No"}
        </span>
      </div>

      <div className="-mx-5 overflow-x-auto">
        <table className="w-full min-w-[640px] table-auto border-collapse">
          <thead>
            <tr className="border-b bg-white text-[10px] uppercase tracking-widest text-gray-500">
              {HEADERS.map((h) => (
                <th
                  key={h}
                  className="px-3 py-2 text-left font-semibold whitespace-nowrap first:pl-5 last:pr-5"
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {codes.map((row, index) => (
              <tr
                key={row.object_type}
                className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
              >
                <td className="py-2 pl-5 pr-3 text-xs font-medium text-gray-900 whitespace-nowrap">
                  {row.label}
                </td>
                <td className="px-3 py-2 text-xs text-gray-700 whitespace-nowrap">
                  {row.prefix}
                </td>
                <td className="px-3 py-2 text-xs text-gray-700 whitespace-nowrap">
                  {row.code}
                </td>
                <td className="py-2 pl-3 pr-5 text-xs font-medium text-gray-900 whitespace-nowrap">
                  {row.code_preview}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  </Section>
);

export default ObjectCodesView;
